import CircularProgress from '@material-ui/core/CircularProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import BlockIcon from '@material-ui/icons/Block'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import EventNoteIcon from '@material-ui/icons/EventNote'
import MoneyIcon from '@material-ui/icons/LocalAtm'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    expediaInventoryAvailability,
    expediaInventoryOrder,
    expediaPushYearAvailability,
    expediaPushYearPrices,
    expediaPushYearRestrictions
} from '../../../../../api/expediaApi/expediaSync'
import { selectCurrentOrganization } from '../../../../../selectors/expediaSelectors/expediaCurrentOrganization'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        width: '95%'
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class SyncTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    }

    handlePushYearPrices = () => this.props.expediaPushYearPrices({ organizationId: [this.props.organizationId] })

    handlePushYearRestrictions = () =>
        this.props.expediaPushYearRestrictions({ organizationId: [this.props.organizationId] })

    handlePushYearAvailability = () =>
        this.props.expediaPushYearAvailability({ organizationId: [this.props.organizationId] })

    handleInventoryAvailability = () =>
        this.props.expediaInventoryAvailability({ organizationId: this.props.organizationId })

    handleInventoryOrder = () => this.props.expediaInventoryOrder({ organizationId: this.props.organizationId })

    render() {
        const {
            classes,
            pendingPushYearPrices,
            pendingPushYearRestrictions,
            pendingPushYearAvailability,
            pendingInventoryAvailability,
            pendingInventoryOrder
        } = this.props
        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <List>
                        <ListItem button onClick={this.handlePushYearPrices} disabled={pendingPushYearPrices}>
                            <ListItemIcon>
                                <MoneyIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить цены"
                                secondary="Это действие отправляет цены в Expedia.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearPrices && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handlePushYearRestrictions}
                            disabled={pendingPushYearRestrictions}
                        >
                            <ListItemIcon>
                                <BlockIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить ограничения"
                                secondary="Это действие отправляет ограничения в Expedia.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearRestrictions && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handlePushYearAvailability}
                            disabled={pendingPushYearAvailability}
                        >
                            <ListItemIcon>
                                <EventAvailableIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить доступность"
                                secondary="Это действие отправляет доступность в Expedia.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearAvailability && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handleInventoryAvailability}
                            disabled={pendingInventoryAvailability}
                        >
                            <ListItemIcon>
                                <EventAvailableIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory доступности"
                                secondary="Это действие сравнивает доступность в Expedia.com и EasyMS. В случае несоответствия обновленная доступность отсылается в Expedia.com"
                            />
                            <ListItemSecondaryAction>
                                {pendingInventoryAvailability && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem button onClick={this.handleInventoryOrder} disabled={pendingInventoryOrder}>
                            <ListItemIcon>
                                <EventNoteIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory заказов"
                                secondary="Это действие проверяет все ли бронирования из Expedia.com, у которых дата выезда в будущем, есть в EasyMS. Если нет, то эти бронирования будут добавлены в EasyMS"
                            />
                            <ListItemSecondaryAction>
                                {pendingInventoryOrder && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    organizationId: selectCurrentOrganization(state),
    pendingPushYearPrices: state.expediaSync.pendingPushYearPrices,
    pendingPushYearRestrictions: state.expediaSync.pendingPushYearRestrictions,
    pendingPushYearAvailability: state.expediaSync.pendingPushYearAvailability,
    pendingInventoryAvailability: state.expediaSync.pendingInventoryAvailability,
    pendingInventoryOrder: state.expediaSync.pendingInventoryOrder
})

export default connect(
    mapStateToProps,
    {
        expediaPushYearPrices,
        expediaPushYearRestrictions,
        expediaPushYearAvailability,
        expediaInventoryAvailability,
        expediaInventoryOrder
    }
)(withStyles(styles)(SyncTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/SyncTab/SyncTab.js